class AjaxCollectionPages extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.loadMoreBtn = this.querySelector('#product-grid-pagination .pagination__load-button');
        this.status = document.querySelector('.pagination__load-status .infinite-scroll-request');
        this.loadingError = document.querySelector('.pagination__load-status .infinite-scroll-error');
        this.rootUrl = this.getAttribute("data-root-url");

        this.collectionHandle = this.getAttribute('data-collection-handle');
        this.currentPageNumber = this.getAttribute("data-current-page");
        this.nextPageNumber = parseInt(this.currentPageNumber) + 1;
        this.productsPerPage = parseInt(this.getAttribute("data-products_per_page"));
        this.sectionId = this.getAttribute("data-section-id");

        if(this.loadMoreBtn){
            this.loadMoreBtn.addEventListener('click', this.loadMoreProducts.bind(this));
        }
        this.paginationList = document.querySelector('#product-grid-pagination .pagination__list.list-unstyled');
        this.paginationStatus = document.querySelector('#product-grid-pagination .pagination__status');
    }

    loadMoreProducts(e) {
        e.preventDefault();
        
        const nextPageUrl = this.rootUrl + "collections/" + this.collectionHandle + "?page=" + this.nextPageNumber + "&section_id=" + this.sectionId;
        this.loadMoreBtn.classList.add('visually-hidden');
        this.status.classList.remove('visually-hidden');
        this.loadingError.classList.add('visually-hidden');
    
        fetch(nextPageUrl)
            .then(response => response.text())
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
    
                const productGrid = document.querySelector('#product-grid');
                const newItems = doc.querySelectorAll('#product-grid .grid__item');
                const newNextBtn = doc.querySelector('#product-grid-pagination .pagination__load-button');
                const newPaginationList = doc.querySelector('#product-grid-pagination .pagination__list.list-unstyled');
                const newPaginationStatus = doc.querySelector('#product-grid-pagination .pagination__status');
    
                // Use a DocumentFragment for efficient DOM updates
                const fragment = document.createDocumentFragment();
                newItems.forEach(item => fragment.appendChild(item));
                productGrid.appendChild(fragment);
                this.nextPageNumber = this.nextPageNumber + 1;
    
                // Update pagination button if more pages exist
                if (newNextBtn) {
                    this.loadMoreBtn.setAttribute('href', newNextBtn.getAttribute('href'));
                    this.loadMoreBtn.classList.remove('visually-hidden');
                } else {
                    this.loadMoreBtn.classList.add('visually-hidden');
                }
    
                // Update pagination UI
                if (this.paginationList && newPaginationList) {
                    this.paginationList.innerHTML = newPaginationList.innerHTML;
                }
    
                if (this.paginationStatus && newPaginationStatus) {
                    this.paginationStatus.innerHTML = newPaginationStatus.innerHTML;
                }
    
                this.status.classList.add('visually-hidden');
                this.loadingError.classList.add('visually-hidden');
                // productGrid.innerHTML += nextPageProducts;

                //updating session storage with newer products
                // sessionStorage.setItem('productGridHtml', productGrid.innerHTML);
                // const productGridPagination = document.querySelector('#product-grid-pagination');
                // sessionStorage.setItem('productGridPagination', productGridPagination.innerHTML);
                //

            })
            .catch(error => {
                console.error('Error loading more products:', error);
                this.loadMoreBtn.classList.remove('visually-hidden');
                this.status.classList.add('visually-hidden');
                this.loadingError.innerHTML = this.loadingError.innerHTML + error;
                this.loadingError.classList.remove('visually-hidden');
            });
    }


}

customElements.define('ajax-collection-pages', AjaxCollectionPages);